import { withStyles, Tabs, Tab } from '@material-ui/core';
import RefreshBar from '../../Common/RefreshBar';

const styles = (theme) => ({
  container: {
    padding: '2px 24px 0px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent:'space-between',
    marginBottom:"4px",
    borderBottom:`1px solid ${theme.AppBGColor}`
  },
  tabsIndicator: {
    backgroundColor: theme.HeaderSelectedText
  },
  tabRoot: {
    fontWeight: '600',
    fontSize: theme.textFontSize,
    color: theme.iconColor,
    textTransform: 'none',
    opacity: 1,
    minWidth: 60,
    '&:hover': {
      color: theme.HeaderSelectedText
    },
    '&$tabSelected': {
      color: theme.HeaderSelectedText
    },
    '&:focus': {
      color: theme.HeaderSelectedText
    }
  },
  tabSelected: {
    color: theme.HeaderSelectedText
  },
  status: {
    fontWeight: '600',
    fontSize: theme.textFontSize,
    color: theme.iconColor,
    marginRight: 12
  },
  statusCount: {
    color: theme.iconColor
  },
  rightSection: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: "12px"
  },
  total: {
    fontWeight: '600',
    fontSize: theme.textFontSize,
    color: theme.iconColor,
  }
});
const GridTabHeader = ({
  classes,
  handleTabChange,
  tabId,
  tabList,
  headerId,
  gridName,
  handleRefresh,
  totalLabel = `Total ${gridName} Count`,
  selectedLabel = `Selected ${gridName} Count`
}) => {
  const tabClasses = { root: classes.tabRoot, selected: classes.tabSelected };
  const { totalCount, selectedCount } = tabList.reduce(
    (acc, tab) => {
      acc.totalCount += tab.totalCount;
      acc.selectedCount += tab.selectedCount;
      return acc;
    },
    { totalCount: 0, selectedCount: 0 }
  );
  return (
    <div id="gridHeader" className={classes.container}>
      <div className={classes.status}>
        <div>Status</div>
        <div>{`(Total ${gridName}s | Selected ${gridName}s)`}</div>
      </div>
      <Tabs
        value={tabId}
        onChange={handleTabChange}
        classes={{
          root: classes.tabsRoot,
          indicator: classes.tabsIndicator
        }}>
        {tabList?.map((tab) => (
          <Tab
            key={tab.id}
            disableRipple
            label={
              <>
                <div>{tab.name}</div>
                <div className={classes.statusCount}>
                  {tab.totalCount}|{tab.selectedCount}
                </div>
              </>
            }
            classes={tabClasses}
            value={tab.id}
          />
        ))}
      </Tabs>
      <div className={classes.rightSection}>
        <RefreshBar handleRefreshClick={handleRefresh} headerId={headerId}/>
        <div className={classes.total}>
          <span>
            {totalLabel}: {totalCount}
          </span>
          &nbsp;|&nbsp;
          <span>
            {selectedLabel}: {selectedCount}
          </span>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(GridTabHeader);
